// @flow
import config from '../../config';
import { buildQueryParams } from './search-weather-impact-request';
import { createApiCall } from './api-factory';

const BASE_URL = config.WEATHER_IMPACT_URL;

const makeApiCall = createApiCall(BASE_URL, buildQueryParams);

const getWeatherImpactSummary = (query): any => makeApiCall('/summary', query);

const getWeatherImpactEventMix = (query): any => makeApiCall('/event_mix', query);

const getWeatherImpactCarrierPerformance = (query): any => makeApiCall('/carrier_performance', query);

const getWeatherImpactShipmentReport = (query): any => makeApiCall('/shipment_report', query);

const getWeatherImpactWarehouseImpact = (query): any => makeApiCall('/warehouse_impact', query);

const getWeatherImpactEventSummary = (query): any => makeApiCall('/event_summary', query);

const getWeatherImpactMap = (query): any => makeApiCall('/map', query);

export {
    getWeatherImpactSummary,
    getWeatherImpactEventMix,
    getWeatherImpactCarrierPerformance,
    getWeatherImpactShipmentReport,
    getWeatherImpactWarehouseImpact,
    getWeatherImpactEventSummary,
    getWeatherImpactMap,
};
